import Actions from "./Action";
import DownloadFileData from "./DownloadFileData";

export default [
	{ title: 'File name', field: 'name', component: DownloadFileData},
	{ title: 'Uploaded by', field: 'created_by_name' },
	// { title: 'Fundout file id', field: 'fundout_file_id' },
	{ title: 'Inserted record', field: 'inserted_record' },
	{ title: 'Updated record', field: 'updated_record' },
	{ title: 'Failed record', field: 'failed_record' },
	{ title: 'Uploaded at', field: 'created_at' },
	// { title: 'Updated at', field: 'updated_at' },
	{ title: 'Action', field: '', component: Actions }
];